export const Section1 = {
	heading: 'How to get your brand noticed on Beacon Discovery',
	para1:
		'You have your booth design and marketing for Natural Products Expos nailed down with bright colors, catchy outfits for your team, and of course delicious samples, but how can your brand stand out on New Hope Network’s new digital product directory, Beacon Discovery?',
	para2: 'Follow these tips to maximize your leads on Beacon:'
};

export const Section2 = {
	heading: 'Upload high quality images',
	para: 'Picture Beacon as a match-making service that connects your brand to the perfect retailers. You want your products to look hot! Be sure to submit high-resolution images of all sides of your products, including a labeling flat. Acceptable file formats include PNG, JPG, or JPEG. Images should exceed a minimum resolution of 1000×1000. Don’t forget to include your product dimensions!'
};

export const Section3 = {
	heading: 'Display your HowGood Impact Estimate',
	para: {
		content1:
			'Beacon has partnered with HowGood, a third-party sustainability database for food companies that measures both the environmental and social impact scores of your product and then puts them into context with others. At no extra cost, ',
		content2_link: 'HowGood',
		content3:
			' will calculate a sustainability assessment for your products, which can be displayed on the product page.'
	}
};

export const Section4 = {
	heading: 'Apply for a Market Ready Verified badge',
	para: {
		content1: 'Did you know that New Hope Network has its own regulatory consulting service, ',
		content2_link: 'MarketReady Insights',
		content3:
			'? Our regulatory experts will review your product labels and marketing for regulatory compliance and once you’ve implemented the necessary changes, you can display your Market Ready Verified Badge next to each of your products that have been reviewed.'
	}
};

export const Section5 = {
	heading: 'Remember to add new products',
	para1:
		'You can add new products to Beacon at any time! Products launched within the last year will display on the ‘What’s New’ tab, increasing your brand’s visibility.',
	para2: {
		content1:
			'Did you know? A year-long subscription to Beacon is included in every booth package for Natural Products Expo West and Newtopia Now and also available as a standalone package even if your brand is not exhibiting at one of our shows. Have you visited Beacon yet? Log on today and discover thousands of new products. For more information get in touch with us at ',
		content2_link: 'beacondiscovery@newhope.com.'
	}
};

export enum Links {
	howgood = 'https://beacon.newhope.com/howgood/',
	market_ready_insights = 'https://marketreadyinsights.com/'
}

export enum Images {
	acure = 'https://s44021.pcdn.co/wp-content/uploads/2024/05/beacon-acure-narrow.webp',
	howgood_estimate = 'https://s44021.pcdn.co/wp-content/uploads/2024/05/beacon-how-good-score-narrow.webp',
	market_ready_verified = 'https://s44021.pcdn.co/wp-content/uploads/2024/05/market-ready-narrow.webp',
	new_to_market = 'https://s44021.pcdn.co/wp-content/uploads/2024/05/new-to-market-beacon-narrow.webp'
}
